import {
  BrowserCacheLocation,
  PublicClientApplication,
  type Configuration,
  type RedirectRequest,
} from "@azure/msal-browser";

// Inspector's Entra ID app registration. The wavely zoom-app uses a separate
// registration; ours exposes the `user_impersonation` scope only.
const clientId = import.meta.env.VITE_AZURE_AD_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_AD_TENANT_ID;

if (!clientId || !tenantId) {
  // Surface this loudly during dev. In prod the env vars are baked in at
  // build time so the SPA never ships without them.
  // eslint-disable-next-line no-console
  console.warn(
    "VITE_AZURE_AD_CLIENT_ID / VITE_AZURE_AD_TENANT_ID are not set; auth flows will fail.",
  );
}

const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "",
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // LocalStorage matches the wavely pattern — survives tab close, plays
    // nicely with the redirect flow. The cookie flag works around Safari /
    // ITP cases where third-party storage is blocked mid-redirect.
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
};

export const pca = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: clientId ? [`api://${clientId}/user_impersonation`] : [],
};
